export default __webpack_public_path__ + "static/media/person.5200e614.svg";